<template>
    <li class="athlete__block" v-if="athlete">
        <a :href="athlete.link">

            <div class="athlete__medals">
                <div class="athlete__medal" v-if="athlete.acf.gold_medals > 0">
                    <span>
                        <span class="vh">
                            {{ printString('gold_medals') }}
                        </span>
                        <span v-html="ico_gold"/>
                    </span>
                    <p>
                        {{athlete.acf.gold_medals}}
                    </p>
                </div>
                <div class="athlete__medal" v-if="athlete.acf.silver_medals > 0">
                    <span>
                        <span class="vh">
                            {{ printString('silver_medals') }}
                        </span>
                        <span v-html="ico_silver"/>
                    </span>
                    <p>
                        {{athlete.acf.silver_medals}}
                    </p>
                </div>
                <div class="athlete__medal" v-if="athlete.acf.bronze_medals > 0">
                    <span>
                        <span class="vh">
                            {{ printString('bronze_medals') }}
                        </span>
                        <span v-html="ico_bronze"/>
                    </span>
                    <p>
                        {{athlete.acf.bronze_medals}}
                    </p>
                </div>

            </div>
            <figure v-if="athlete.athlete_thumbnail" v-html="athlete.athlete_thumbnail"></figure>
            <figure v-else>
                <img :src="athlete.athlete_fallback.sizes.medium" :alt="athlete.athlete_fallback.alt"/>
            </figure>
            <h3 class="step--1">
                <span v-html="athlete.acf.first_name"/>
                <span v-html="athlete.acf.last_name"/>
            </h3>
            <div class="athlete__sports">
                <p  v-for="(single_sport, index) in athlete.athlete_sport" :key="index">
                    {{single_sport.post_title}}
                </p>
            </div>
        </a>
    </li>
</template>

<script>
    export default {
        props: {
            athlete: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                ico_gold : window.ico_gold,
                ico_silver : window.ico_silver,
                ico_bronze : window.ico_bronze,
            }
        },
        methods: {
            printString( string ){
                return window.translations[string]
            }
        }
    };
</script>
